export const INVIA_TYPE_GROUP_PROMOTION = 'IT08P';
export const INVIA_TYPE_GROUP_FLEX = 'IT08F';
export const INVIA_TYPE_GROUP_SAFETY = 'IT08S';
export const EXPEDIA_TYPE_CANCELLATION_RULE_REFUNDABLE = 'EPS#REF#FULL';
export const EXPEDIA_TYPE_CANCELLATION_RULE_NON_REFUNDABLE = 'EPS#REF';